import React, { useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";

import sarry_logo from "../assets/sarry_logo.png";
import sarry_favicon from "../assets/vastrudayam_favicon.png";

// Create a context for sidebar state
export const SidebarContext = React.createContext();

const Sidebar = ({ isCollapsed, toggleSidebar }) => {
  const [hoveredItem, setHoveredItem] = useState(null);

  const menuItems = [
    { path: "/admin/dashboard", icon: "bi bi-speedometer2", label: "Dashboard" },
    { path: "/admin/products", icon: "bi bi-box-seam", label: "Products" },
    { path: "/admin/categories", icon: "bi bi-grid", label: "Categories" },
    { path: "/admin/navigation", icon: "bi bi-list-ul", label: "Navigation / Menus" },
    { path: "/admin/orders", icon: "bi bi-cart-check", label: "Orders" },
    { path: "/admin/stock-notifications", icon: "bi bi-bell", label: "Stock Notifications" },
    { path: "/admin/wishlist", icon: "bi bi-heart", label: "Wishlists" },
    { path: "/admin/abandoned-cart", icon: "bi bi-cart-x", label: "Abandoned Carts" },
    { path: "/admin/returns", icon: "bi bi-arrow-return-left", label: "Returns / Verification" },
    { path: "/admin/reviews", icon: "bi bi-chat-left-dots", label: "Customer Reviews" },
    { path: "/admin/support-tickets", icon: "bi bi-robot", label: "Support Tickets" },
    { path: "/admin/users", icon: "bi bi-people", label: "Users" },
    { path: "/admin/coupons", icon: "bi bi-ticket-perforated", label: "Coupons" },
    { path: "/admin/banners", icon: "bi bi-image", label: "Banners" },
    { path: "/admin/reports", icon: "bi bi-bar-chart", label: "Reports" },
    { path: "/admin/settings", icon: "bi bi-gear", label: "Settings" }
  ];

  return (
    <div className={`admin-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-logo-container">
        {/* Show full logo when expanded, show favicon when collapsed */}
        {!isCollapsed ? (
          <>
            <img src={sarry_logo} className="sidebar-logo" alt="Logo" />
            {/* Mobile close button – only visible when expanded on mobile */}
            <button className="sidebar-mobile-close" onClick={toggleSidebar}>
              <i className="bi bi-x-lg"></i>
            </button>
          </>
        ) : (
          <img src={sarry_favicon} className="sidebar-favicon" alt="Favicon" />
        )}
      </div>

      <ul className="sidebar-menu">
        {menuItems.map((item) => (
          <li 
            key={item.path}
            className="sidebar-menu-item"
            onMouseEnter={() => setHoveredItem(item.path)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <NavLink 
              to={item.path} 
              className="sidebar-link"
              onClick={() => {
                if (window.innerWidth <= 768 && !isCollapsed) {
                  toggleSidebar();
                }
              }}
            >
              <i className={item.icon}></i>
              {!isCollapsed && <span>{item.label}</span>}
              {isCollapsed && hoveredItem === item.path && (
                <div className="sidebar-tooltip">{item.label}</div>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;